/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ email: NonNullable<unknown> }} Code_Sent_ToInputs */

const th_code_sent_to = /** @type {(inputs: Code_Sent_ToInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`ส่งรหัสไปที่ ${i?.email} แล้ว รหัสจะหมดอายุใน 10 นาที`)
};

const en_code_sent_to = /** @type {(inputs: Code_Sent_ToInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Code sent to ${i?.email}. It expires in 10 minutes.`)
};

const ja_code_sent_to = /** @type {(inputs: Code_Sent_ToInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.email} に認証コードを送信しました。10分で期限切れとなります。`)
};

const zh_code_sent_to = /** @type {(inputs: Code_Sent_ToInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`验证码已发送至 ${i?.email}，10 分钟后失效。`)
};

const es_code_sent_to = /** @type {(inputs: Code_Sent_ToInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Código enviado a ${i?.email}. Caduca en 10 minutos.`)
};

const pt_code_sent_to = /** @type {(inputs: Code_Sent_ToInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Código enviado para ${i?.email}. Expira em 10 minutos.`)
};

const id_code_sent_to = /** @type {(inputs: Code_Sent_ToInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Kode dikirim ke ${i?.email}. Kode berlaku 10 menit.`)
};

const fr_code_sent_to = /** @type {(inputs: Code_Sent_ToInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Code envoyé à ${i?.email}. Il expire dans 10 minutes.`)
};

const tl_code_sent_to = /** @type {(inputs: Code_Sent_ToInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Ipinadala ang code sa ${i?.email}. Mag-e-expire ito sa loob ng 10 minuto.`)
};

const vi_code_sent_to = /** @type {(inputs: Code_Sent_ToInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Đã gửi mã tới ${i?.email}. Mã hết hạn sau 10 phút.`)
};

const ko_code_sent_to = /** @type {(inputs: Code_Sent_ToInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.email}(으)로 코드를 보냈습니다. 10분 후 만료됩니다.`)
};

const de_code_sent_to = /** @type {(inputs: Code_Sent_ToInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Code an ${i?.email} gesendet. Er läuft in 10 Minuten ab.`)
};

const ru_code_sent_to = /** @type {(inputs: Code_Sent_ToInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Код отправлен на ${i?.email}. Он истечёт через 10 минут.`)
};

const tr_code_sent_to = /** @type {(inputs: Code_Sent_ToInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Kod ${i?.email} adresine gönderildi. 10 dakika içinde geçerliliğini yitirir.`)
};

const it_code_sent_to = /** @type {(inputs: Code_Sent_ToInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Codice inviato a ${i?.email}. Scade tra 10 minuti.`)
};

const pl_code_sent_to = /** @type {(inputs: Code_Sent_ToInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Kod wysłany na ${i?.email}. Wygaśnie za 10 minut.`)
};

const uk_code_sent_to = /** @type {(inputs: Code_Sent_ToInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Код надіслано на ${i?.email}. Він діє 10 хвилин.`)
};

const hi_code_sent_to = /** @type {(inputs: Code_Sent_ToInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`कोड ${i?.email} पर भेजा गया। यह 10 मिनट में समाप्त हो जाएगा।`)
};

const ar_code_sent_to = /** @type {(inputs: Code_Sent_ToInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`أُرسل الرمز إلى ${i?.email}. ينتهي خلال 10 دقائق.`)
};

const ms_code_sent_to = /** @type {(inputs: Code_Sent_ToInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Kod dihantar ke ${i?.email}. Ia luput dalam 10 minit.`)
};

const bn_code_sent_to = /** @type {(inputs: Code_Sent_ToInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.email}-এ কোড পাঠানো হয়েছে। এটি ১০ মিনিটে শেষ হবে।`)
};

const zh_tw2_code_sent_to = /** @type {(inputs: Code_Sent_ToInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`驗證碼已寄至 ${i?.email}，10 分鐘後失效。`)
};

const zh_hk2_code_sent_to = /** @type {(inputs: Code_Sent_ToInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`驗證碼已寄至 ${i?.email}，10 分鐘後失效。`)
};

const ur_code_sent_to = /** @type {(inputs: Code_Sent_ToInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`کوڈ ${i?.email} پر بھیج دیا گیا۔ یہ 10 منٹ میں ختم ہو جائے گا۔`)
};

const fa_code_sent_to = /** @type {(inputs: Code_Sent_ToInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`کد به ${i?.email} فرستاده شد. تا ۱۰ دقیقه اعتبار دارد.`)
};

const sw_code_sent_to = /** @type {(inputs: Code_Sent_ToInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Msimbo umetumwa kwa ${i?.email}. Utaisha baada ya dakika 10.`)
};

const nl_code_sent_to = /** @type {(inputs: Code_Sent_ToInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Code verstuurd naar ${i?.email}. Hij vervalt over 10 minuten.`)
};

/**
* | output |
* | --- |
* | "Code sent to {email}. It expires in 10 minutes." |
*
* @param {Code_Sent_ToInputs} inputs
* @param {{ locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }} options
* @returns {LocalizedString}
*/
export const code_sent_to = /** @type {((inputs: Code_Sent_ToInputs, options?: { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Code_Sent_ToInputs, { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "th") return th_code_sent_to(inputs)
	if (locale === "ja") return ja_code_sent_to(inputs)
	if (locale === "zh") return zh_code_sent_to(inputs)
	if (locale === "es") return es_code_sent_to(inputs)
	if (locale === "pt") return pt_code_sent_to(inputs)
	if (locale === "id") return id_code_sent_to(inputs)
	if (locale === "fr") return fr_code_sent_to(inputs)
	if (locale === "tl") return tl_code_sent_to(inputs)
	if (locale === "vi") return vi_code_sent_to(inputs)
	if (locale === "ko") return ko_code_sent_to(inputs)
	if (locale === "de") return de_code_sent_to(inputs)
	if (locale === "ru") return ru_code_sent_to(inputs)
	if (locale === "tr") return tr_code_sent_to(inputs)
	if (locale === "it") return it_code_sent_to(inputs)
	if (locale === "pl") return pl_code_sent_to(inputs)
	if (locale === "uk") return uk_code_sent_to(inputs)
	if (locale === "hi") return hi_code_sent_to(inputs)
	if (locale === "ar") return ar_code_sent_to(inputs)
	if (locale === "ms") return ms_code_sent_to(inputs)
	if (locale === "bn") return bn_code_sent_to(inputs)
	if (locale === "zh-TW") return zh_tw2_code_sent_to(inputs)
	if (locale === "zh-HK") return zh_hk2_code_sent_to(inputs)
	if (locale === "ur") return ur_code_sent_to(inputs)
	if (locale === "fa") return fa_code_sent_to(inputs)
	if (locale === "sw") return sw_code_sent_to(inputs)
	if (locale === "nl") return nl_code_sent_to(inputs)
	return en_code_sent_to(inputs)
});